<template>

  <div :class="{'node-project' : isProject, 'node-ws' : isWorkspace}">
    <span style="display: none;">.</span>
    <div v-if="task_id && isVisible"
         :class="'drop ' + (activeTaskID == task.id ? 'active' : '') + ' task-item state-'+task.state  ">

      <drop @drop="handleDrop" @dragover="taskOver=true" @dragleave="taskOver=false"
            :class="(taskOver ? ' drag-over ' : '') + (depth > 0 ? '' : '')"
            :style="'margin-left:'+((depth > 2 ? depth - 1 : 0) * nodeLeftMargin)+'px'">

        <b-input-group>

          <b-input-group-prepend>

            <template v-if="!isProject && !isWorkspace">
              <!--span class="project" v-if="!task.is_supervisor">{{task.parent_project}}</span!-->

              <div class="icon toggler">

                <a @click="emit('toggle', task)" v-if="!task.expanded">
                  <v-icon
                      :name="children_count > 0 ? 'plus-circle' : 'chevron-right'"></v-icon>
                </a>
                <a @click="emit('toggle', task)" v-if="task.expanded==1">
                  <v-icon :name="children_count ? 'minus-circle' : 'chevron-down'"></v-icon>
                </a>

                <a @click="emit('toggle', task)" v-if="task.expanded==2">
                  <v-icon name="loader"></v-icon>
                </a>

              </div>

            </template>


          </b-input-group-prepend>

          <template v-if="title !== undefined">
            <b-form-input
                :class="'task-title task-control ' + (isDeferred ? ' deferred ' : '') + ' enabled-'+task.active + ' task-' + task.type"
                :id="'task-'+task.id"
                autocomplete="off"
                @focus="emit('activate', task)"
                @keydown="keydown"
                :data-id="task.id"
                v-model="title"
                :readonly="!task.is_supervisor || task.readonly || isMobile"
                ref="task-title"></b-form-input>

            <template v-if="activeTaskID == task.id">{{ focusTask() }}</template>

          </template>
          <template v-else>
            <div class="task-loader task-control">
              <v-icon name="loader"></v-icon>
            </div>
          </template>

          <b-input-group-append>

            <template v-if="treeRenderMode === 'all'">

              <drag v-if="!isWorkspace && allowWrite(task) && !isMobile" class="icon drag"
                    :transfer-data="task">
                <v-icon name="align-justify"></v-icon>
                <div slot="image" class="task-dragged">
                  {{ task.title }}
                </div>
              </drag>

              <template v-if="!isMobile && activeTaskID == task.id">
                <b-dropdown class="show_all icon" variant="light" right text="">
                  <b-dropdown-item @click="toggleAwaitChildren(task.id)">{{$get('tree/getAwaitChildrenMode', task.id) ? "Hide" : "Show"}} inactive tasks</b-dropdown-item>
                  <b-dropdown-item @click="toggleClosedChildren(task.id)">{{$get('tree/getClosedChildrenMode', task.id) ? "Hide" : "Show"}} closed</b-dropdown-item>
                  <b-dropdown-item @click="toggleDeferredChildren(task.id)">{{$get('tree/getDeferredChildrenMode', task.id) ? "Hide" : "Show"}} deferred</b-dropdown-item>
                </b-dropdown>
              </template>

            </template>

            <div class="badges" v-if="treeRenderMode==='all' || !children_count">
                <span v-if="isMobile && activeTaskID == task.id" class="nodes_opener" @click="gotoTask(task.id)">
                  <b-icon icon="arrow-right-square"></b-icon>
                </span>

              <!-- Node expander !-->
              <span v-if="!isProject && !isWorkspace" class="nodes_expander" @click="expandNode(task.id)">
                  <v-icon v-if="children_count" name="chevron-right"></v-icon>
                </span>

              <template v-for="(not, nk) in $get('notifications/getTreeNotificationsList')">
                <node-notification-badges v-if="allowedBadges.includes(not.type) || treeRenderMode==='all'"
                                          :iconClassName="not.className" :key="'nb-'+nk" :title="not.title"
                                          :globalIcon="not.globalIcon" :localIcon="not.localIcon" :node="task"
                                          @openNotification="openNotification"
                                          :type="not.type"/>

                <!--                                           :onlyLocal="(task.expanded && !isProject) || (treeRenderMode !== 'all')" !-->
              </template>
            </div>

            <template v-if="treeRenderMode === 'all'">

              <template v-if="allowWrite(task) && !isProject">
                <input v-show="activeTaskID != task.id" class="task-relation" type="checkbox"
                       :checked="checkDependepcy(task)"
                       @change="emit('dependency', {task: task, activeTask: activeTask, mode: $event.target.checked})"/>

                <v-icon class="icon" v-show="task.dependencies && task.dependencies.length"
                        name="corner-down-left"></v-icon>
              </template>

            </template>

            <gant-lane v-if="gantt" :node="task" @laneClick="$emit('showLaneInfo', $event)"/>

          </b-input-group-append>
        </b-input-group>

      </drop>
    </div>
    <template v-if="task && (task.expanded==1 || isProject || isWorkspace)">
      <task-tree-item :filter="filter" v-for="(child, key) in tasksList" :gantt="gantt" :key="'treeitem-'+child.id"
                      @showLaneInfo="$emit('showLaneInfo', $event)"
                      :task_id="child.id"
                      :treeRenderMode="treeRenderMode"
                      :position="key"
                      :depth="parseInt(depth)+1"/>
    </template>
  </div>

</template>

<script>

import _ from 'lodash'
import {Drag, Drop} from 'vue-drag-drop';
import NodeNotificationBadges from "./NodeNotificationBadges";
import GantLane from "./Gantt/GantLane";
import {synchronizer} from '../../../utils/synchronizer'

export default {
  props: ["task_id", "depth", "position", "gantt", "filter", "treeRenderMode"],
  components: {GantLane, NodeNotificationBadges, Drag, Drop},
  data() {
    return {
      taskOver: false,
      currentTitle: false,
    }
  },
  name: "tree-item",

  watch: {
    'activeTaskID': function () {
      this.focusActiveTask();
    }
  },
  computed:
      {

        /**
         * Allowed badges list
         * @returns {string[]}
         */
        allowedBadges() {
          switch (this.treeRenderMode) {
            case "my-list":
              return ['comment', 'mention-comment',  'my-task-4-today', 'assignee', 'acceptor', 'forgotten-task', 'overlogged'];
            case "has-kpi":
              return ['comment', 'mention-comment', 'has-kpi'];
            case "problem-kpi":
              return ['comment', 'mention-comment', 'problem-kpi'];
            case "forgotten-task":
              return ['comment', 'mention-comment', 'task-4-today', 'forgotten-task'];
            case "task-4-today":
              return ['comment', 'mention-comment', 'task-4-today'];
            case "my-task-4-today":
              return ['comment', 'mention-comment', 'my-task-4-today'];
            case "assignee":
              return ['comment', 'mention-comment', 'my-task-4-today', 'assignee'];
            case "in-progress":
              return ['comment', 'mention-comment', 'in-progress', 'task-4-today'];
            default:
              return [this.treeRenderMode, 'comment', 'mention-comment'];
          }
        },

        /**
         * Check is that mobile
         * @returns {RegExpMatchArray}
         */
        isMobile() {
          return this.$api.isMobile();
        },

        /**
         * Node margin
         * @returns {number}
         */
        nodeLeftMargin() {
          return this.isMobile ? 5 : 10;
        },

        /**
         * Is deferred
         */

        isDeferred() {
          return this.task.deferred / 1000 > this.$api.getUnixTime() || this.task.min_start_time / 1000 > this.$api.getUnixTime();
        },

        /**
         * Check is task visible
         */

        isVisible() {
          // Visible
          return this.task;
        },

        /**
         * Check is node root
         */

        isProject() {
          return this.task_id && this.task && this.task.type == 'project'
        },

        /**
         * Check for children hidden mode
         */

        isHiddenChildrenShows() {
          return this.$get('tree/getHiddenChildrenMode', this.task_id)
        },

        /**
         * Check is node workspace
         */

        isWorkspace() {
          return this.task_id && this.task && this.task.type == 'workspace';
        },

        /**
         * Current task
         */

        task() {
          // Return fake value for zero node
          if (!this.task_id) return {id: 0, expanded: 1};

          // Get object
          return this.$get("tree/getTaskByID", this.task_id)
        },

        /**
         * Get task children
         */

        children_count() {
          // Get list
          return this.tasksList.length;
        },

        /**
         * Tasks list
         */

        tasksList() {

          // Init result
          let result = [], nots = {};

          // Sort nodes according to tree render mode
          switch (this.treeRenderMode) {

              // Today's tasks TODO
            case "task-4-today":

              // Load nodes list
              result = this.$get("tree/getChildrenTasks", {id: this.task.id, mode:"today"});

              // Fill notifications list
              for (const nd of result) {
                for (const md of ['task-4-today']) {
                  const {info: aInfo, count} = this.$get("notifications/getNotifications", {
                    task_id: nd.id,
                    type: md,
                    zone: "local"
                  });

                  // Init object
                  if (!nots[nd.id]) nots[nd.id] = {};

                  // Store data
                  nots[nd.id][md] = {info: aInfo, count}
                }
              }

              // Sort result
              result.sort((a, b) => {
                return parseInt(nots[a.id]['task-4-today']['info']) > parseInt(nots[b.id]['task-4-today']['info']) ? 1 : -1;
              });
              break

              // My list items
            case "my-list":

              // Load nodes list
              result = this.$get("tree/getChildrenTasks", {id: this.task.id, mode: 'my-list'});

              // Fill notifications list
              for (const nd of result) {
                for (const md of ['my-task-4-today', 'mention-comment', 'acceptor', 'assignee']) {
                  const {info: aInfo, count} = this.$get("notifications/getNotifications", {
                    task_id: nd.id,
                    type: md,
                    zone: "local"
                  });

                  // Init object
                  if (!nots[nd.id]) nots[nd.id] = {};

                  // Store data
                  nots[nd.id][md] = {info: aInfo ? aInfo : 0, count}
                }
              }

              // Sort result
              result.sort((a, b) => {

                // Calc a score
                let aScore =
                    10000000 * parseInt(nots[a.id]['mention-comment']['count']) +
                    100000 * parseInt(nots[a.id]['acceptor']['count']) +
                    10000 * parseInt(nots[a.id]['my-task-4-today']['count']) +
                    100 * (100 - parseInt(nots[a.id]['my-task-4-today']['info'])) +
                    parseInt(nots[a.id]['assignee']['count']);

                // Calc b score
                let bScore =
                    10000000 * parseInt(nots[b.id]['mention-comment']['count']) +
                    100000 * parseInt(nots[b.id]['acceptor']['count']) +
                    10000 * parseInt(nots[b.id]['my-task-4-today']['count']) +
                    100 * (100 - parseInt(nots[b.id]['my-task-4-today']['info'])) +
                    parseInt(nots[b.id]['assignee']['count'])

                //console.log(aScore, bScore, nots[a.id], nots[b.id])

                // Compare items
                return aScore < bScore ? 1 : -1;
              });

              break

            default:
              // Default soering mode
              result = this.$get("tree/getChildrenTasks", {id: this.task.id});
              break
          }

          // Tree is empty
          if (!result.length) this.$emit('emptyNode'); else this.$emit('fullNode');

          // Return result
          return result;
        },


        // Active task
        activeTaskID() {
          // Active task
          return this.$store.getters['tree/getActiveTaskID'];
        },

        /**
         * Get active task object
         */

        activeTask() {
          // Active task
          return this.$store.getters['tree/getTaskByID'](this.$store.getters['tree/getActiveTaskID']);
        },

        // Title field
        title:
            {
              // getter
              get: function () {

                // Check is task loaded
                const taskLoaded = this.task.rendered_title !== undefined ? true : false;

                // Check is node loaded
                if (!this.task.deleted_at && !taskLoaded) {

                  // Send load request
                  synchronizer.addToLoader("tree-task", this.task.id);
                }

                // Return title
                return this.activeTaskID != this.task.id || this.currentTitle === false ? (this.task.rendered_title) : this.currentTitle;
              },
              // setter
              set: _.debounce(function (newValue) {
                this.currentTitle = newValue;
                this.$dispatch(this.task.justCreated ? 'tree/saveTask' : 'tree/setTitle',
                    {
                      id: this.task.id,
                      title: newValue,
                      position: this.task.position,
                      parent_id: this.task.parent_id,
                      instance_id: this.task.instance_id
                    });
              }, 500)
            }
      },

  // On create
  created() {
    this.focusActiveTask()
  },

  // On mount
  mounted() {

  },

  methods: {


    /**
     * Focus task
     */

    focusTask() {

      // Check for task list mode
      if (this.$store.getters['tree/getTaskListMode'] != 'task-list') return;

      // Focus on next tick
      this.$nextTick(() => {
        // Focus task
        let cntr = this.$refs['task-title'];

        // Focus it
        if (cntr) cntr.focus();
      });
    },


    /**
     * Open nod in new page
     * @param nodeId
     */
    gotoTask(nodeId) {
      if (this.isMobile) this.$router.replace({name: 'tree', params: {task_id: nodeId, mode: 'full-task'}})
    },

    /**
     * Toggles hidden children
     * @param nodeId
     */
    toggleClosedChildren(nodeId) {

      // Check mode
      const shcMode = this.$get('tree/getClosedChildrenMode', nodeId) ? 0 : 1

      // Toggle children
      this.$dispatch('tree/showClosedChildren', {id: nodeId, mode: shcMode});

      // Load child nodes in case of show mode
      if (shcMode) this.$dispatch('tree/loadParentStructure', {tags: ["closed"], parent_id: nodeId})
    },

    /**
     * Toggles await children
     * @param nodeId
     */
    toggleAwaitChildren(nodeId) {

      // Check mode
      const shcMode = this.$get('tree/getAwaitChildrenMode', nodeId) ? 0 : 1

      // Toggle children
      this.$dispatch('tree/showAwaitChildren', {id: nodeId, mode: shcMode});
    },

    /**
     * Toggles deferred children
     * @param nodeId
     */
    toggleDeferredChildren(nodeId) {

      // Check mode
      const shcMode = this.$get('tree/getDeferredChildrenMode', nodeId) ? 0 : 1

      // Toggle children
      this.$dispatch('tree/showDeferredChildren', {id: nodeId, mode: shcMode});

      // Load child nodes in case of show mode
      if (shcMode) this.$dispatch('tree/loadParentStructure', {tags: ["deferred"], parent_id: nodeId})
    },

    /**
     * Expand clicked node
     */

    expandNode(nodeId) {
      // Get task id
      const child = this.$get("tree/getFirstActiveChild", nodeId);

      // Go to task
      if (child && child.id) this.$router.push({
        name: 'tree',
        params: {task_id: child.id}
      }).catch(() => {
      });
    },

    /**
     * Open comment notification
     */

    openNotification(type) {
      // Get task id
      let taskID = this.$get("notifications/getFirstNotification", {task_id: this.task.id, type: type});

      // Get first notification
      if (taskID && !this.isMobile) this.$router.push({
        name: 'tree',
        params: {task_id: taskID}
      }).catch(() => {
      });
    },

    /**
     * Get notifications count for task
     */

    notificationsCount(types, zone) {
      // Get count
      return this.task ? this.$get("notifications/getNotificationsCount", {
        task_id: this.task.id,
        type: types,
        zone: zone
      }) : 0;
    },

    /**
     * Check dependency
     */

    checkDependepcy(task) {
      //console.log(this.activeTask.dependencies);
      // Check dependency
      return this.activeTask && this.activeTask.dependencies && (this.activeTask.dependencies.filter((t) => t.parent_id == this.$api.clearInstance(task.id)).length) ? "checked" : "";
    },

    /**
     * Handle drop
     */

    handleDrop(data) {

      // Remove hover highlight
      this.taskOver = false;

      // Call mode
      this.$api.emitParents(this, "change-parent", {task: data, previous: this.task});
    },

    /**
     * Keyboard processing
     */
    keydown(event) {

      // Skip keyboard navigation for mobile mode
      if (this.isMobile) return;

      // Construct key sequence
      let keySeq = event.ctrlKey ? "ctrl-" : "";

      // Alt key
      keySeq += event.altKey ? "alt-" : "";

      // Meta key
      keySeq += event.metaKey ? "meta-" : "";

      // Shift
      keySeq += event.shiftKey ? "shift-" : "";

      // Add key
      keySeq += event.key;

      // Process depending on key
      switch (keySeq) {
        case "Enter":
          // Add new task
          if (this.allowWrite()) this.emit("add", {task: this.task, title: ""});
          break;

          // Delete task
        case "meta-Backspace":

          // Stop prop
          event.preventDefault();

          // Add new task
          if (this.allowWrite()) this.$api.emitParents(this, "delete", this.task);
          break;

          // Expand / collapse
        case "Tab":
          // Add new task
          this.$api.emitParents(this, "toggle", this.task);
          event.preventDefault();
          break;

          // Move selected down
        case "ArrowDown":
          event.preventDefault();
          this.focusNext('down')
          break;

          // Move selected up
        case "ArrowUp":
          event.preventDefault();
          this.focusNext('up')
          break;

          // Move Task down
        case "meta-ArrowDown":
        case "ctrl-ArrowDown":
          event.preventDefault();
          this.$api.emitParents(this, "move", {task: this.task, dir: 'down'});
          break;

          // Move Task up
        case "meta-ArrowUp":
        case "ctrl-ArrowUp":
          event.preventDefault();
          this.$api.emitParents(this, "move", {task: this.task, dir: 'up'});
          break;

          // Move Task down
        case "meta-ArrowRight":
        case "ctrl-ArrowRight":
          this.$api.emitParents(this, "shift", {task: this.task, dir: 'right'});
          event.preventDefault();
          break;

          // Move Task up
        case "meta-ArrowLeft":
        case "ctrl-ArrowLeft":
          this.$api.emitParents(this, "shift", {task: this.task, dir: 'left'});
          event.preventDefault();
          break;
      }
    },


    /**
     * Focus next task
     * */

    focusNext(dir) {

      // Selected element
      let inps = document.querySelectorAll(".task-title");

      // Find next element after active
      for (let i of inps.keys()) if (inps[i] == document.activeElement) {
        // Calc position
        let pos = i + 1 * (dir == 'down' ? 1 : -1);

        // Set focus
        if (pos >= 0 && pos < inps.length) inps[pos].focus();
        break;
      }
    },

    /**
     * Focus task
     */

    focusActiveTask() {

      // Check for task list mode
      if (this.task.id !== this.activeTaskID || this.$store.getters['tree/getTaskListMode'] != 'task-list') return;

      // Focus on next tick
      this.$nextTick(() => {
        // Focus task
        let cntr = this.$refs['task-title'];

        // Focus it
        if (cntr) cntr.focus();
      });
    },

    /**
     * Check for write
     */

    allowWrite() {
      // Check for write access
      return this.task.is_supervisor;
    },

    /**
     * Emit event to parents
     * @param event
     * @param data
     */
    emit(event, data) {
      // Send
      this.$api.emitParents(this, event, data);
    },

  }
}

</script>

<style lang="scss">
@import './src/sass/tree.scss';
</style>
